/* BDC Login - Welcome Sound Trigger
   Sets a flag on login click. Audio plays on /app after redirect (uninterrupted) */

(function() {
    'use strict';

    var WELCOME_SOUND = '/assets/bdcflow_custom/sounds/welcome.mp3';

    function primeAudioEngine() {
        try {
            var audio = new Audio(WELCOME_SOUND);
            audio.volume = 0.001;
            audio.muted = true;
            var p = audio.play();
            if (p && p.then) {
                p.then(function() {
                    audio.pause();
                    audio.currentTime = 0;
                }).catch(function() {});
            }
        } catch (e) {}
    }

    function preloadAudio() {
        try {
            var audio = new Audio(WELCOME_SOUND);
            audio.preload = 'auto';
            audio.load();
        } catch (e) {}
    }

    function markLoginInProgress() {
        try {
            sessionStorage.setItem('bdc_just_logged_in', '1');
            sessionStorage.setItem('bdc_login_timestamp', Date.now().toString());
        } catch (e) {}
    }

    function attachHandlers() {
        var loginBtn = document.querySelector(
            '.btn-login, ' +
            'button.btn-primary[type="submit"], ' +
            'button.btn-login, ' +
            '#login-btn'
        );

        if (loginBtn) {
            loginBtn.addEventListener('click', function() {
                primeAudioEngine();
                markLoginInProgress();
            }, { capture: true });
        }

        var loginForm = document.querySelector('form#login_form, form.login-form');
        if (loginForm) {
            loginForm.addEventListener('submit', function() {
                primeAudioEngine();
                markLoginInProgress();
            }, { capture: true });
        }

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                var emailField = document.getElementById('login_email');
                var passwordField = document.getElementById('login_password');
                if (document.activeElement === emailField || document.activeElement === passwordField) {
                    primeAudioEngine();
                    markLoginInProgress();
                }
            }
        }, { capture: true });
    }

    function init() {
        if (window.location.pathname.indexOf('/login') !== 0 &&
            window.location.pathname !== '/login') {
            return;
        }
        preloadAudio();
        attachHandlers();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
